/*eslint-disable */
export default [
	{
		path: "/",
		component: () => import(/* webpackChunkName: "layout" */ '@/projects/tech-blue/views/layout/index.vue'),
		children: [
			{
				path: '/',
				name: 'index',
				component: () => import(/* webpackChunkName: "page_index" */ '@/projects/tech-blue/views/index/index.vue'),
				meta: { title: '首页', replace: '/', to: '/app' }
			},
			{
				path: '/detail/:staticUrl',
				name: 'page_detail',
				component: () => import(/* webpackChunkName: "page_detail" */ '@/projects/tech-blue/views/detail/index.vue'),
				meta: { title: '详情', replace: '/detail', to: '/app_detail' }
			},
		],
	},
	{
		path: "/",
		component: () => import(/* webpackChunkName: "layout" */ '@/projects/tech-blue/views/layout/app.vue'),
		children: [
			{
				path: '/app',
				name: 'appIndex',
				component: () => import(/* webpackChunkName: "page_index" */ '@/projects/tech-blue/views/index/app.vue'),
				meta: { title: '首页', replace: '/app', to: '/' }
			},
			{
				path: '/app_detail/:staticUrl',
				name: 'appPageDetail',
				component: () => import(/* webpackChunkName: "page_detail" */ '@/projects/tech-blue/views/detail/app.vue'),
				meta: { title: '详情', replace: '/app_detail', to: '/detail' }
			},
		],
	},
];